import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatFormFieldModule } from '@angular/material';
import { FcConfirmCloseDialogComponent } from './fc-confirm-close-dialog.component';

@NgModule({
  entryComponents: [
    FcConfirmCloseDialogComponent
  ],
  declarations: [
    FcConfirmCloseDialogComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule
  ],
  exports: [
    FcConfirmCloseDialogComponent
  ]
})
export class FcConfirmCloseDialogModule { }
